import {NavLink} from "react-router-dom";

import items from "./items";

import styles from "./navbar-menu.module.scss";
import useAuth from "../../../shared/hooks/useAuth";

const getClassName = ({isActive}) => isActive ? `${styles.link} ${styles.active}` : styles.link;

const NavbarMenu = ({mobile = false, onNavigate}) => {
    const {user} = useAuth();
    const elements = items.filter(({requiredRole}) => !requiredRole || user?.role === requiredRole).map(({id, link, text, icon}) => <li key={id} className={styles.item}>
        <NavLink to={link} className={getClassName} onClick={onNavigate}>
            <span className={styles.icon}>{icon}</span> <span className={styles.text}>{text}</span>
        </NavLink>
    </li>);

    return (
        <ul className={`${styles.menu} ${mobile ? styles.mobileMenu : ""}`}>
            {elements}
        </ul>
    )
}

export default NavbarMenu;
